/*
  * A User represents personal information
  * The memberships attribute contains the list of all the Accounts a
    User is either a OWNER, ADMIN or a MEMBER of.
  * A User has 1-to-many relationship with Accounts, defined in the attribute memberships
*/

import Transform from '@app/transformers';
import Helper from '@app/helper';

const sideloaded = window['__session__'] || {};

const {
  id,
  email,
  full_name,
  storageFull,
  preferences,
  profile_picture,
  memberships,
  language,
} = Transform.user(sideloaded.user);

export default {
  id,
  loggedIn: id || false,
  storageFull,
  full_name,
  email,
  language: language,
  profile_picture,
  memberships,
  defaults: {
    profile_picture_thumbnail_url: Helper.getAvatar(id),
  },
  preferences,
};
